/** @jsxImportSource @emotion/react */

import { Copy } from 'lucide-react';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { theme } from 'styles/theme/theme';
import EmptyButton from 'ud-ui/components/empty-button';
import Label from 'ud-ui/components/label';
import UDText from 'ud-ui/components/text';
import UDTippy from 'ud-ui/components/tippy';
import { OrganizerDetails } from 'modules/organizers/domain/interfaces/organizer-details';
import PlansBlock from 'modules/organizers/ui/components/plans-block';
import { CustomField, CustomTextarea, disableColor, InfoContainer } from './styles';

interface OrganizerInfoProps {
  organizer: OrganizerDetails | undefined;
}

const OrganizerInfo = React.memo(function OrganizerInfo({ organizer }: OrganizerInfoProps) {
  const { t } = useTranslation();

  const onClickCopy = (text: string) => {
    navigator.clipboard.writeText(text).then((_) => {
      toast.success('Сохранено в буфер обмена!');
    });
  };

  return (
    <InfoContainer>
      <div className="w-1/2">
        <Label text="Название организатора" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.name}</UDText>
            {organizer?.name && (
              <UDTippy content={'Скопировать'} size={'xs'}>
                <EmptyButton color={theme.colors.Gray} onClick={() => onClickCopy(organizer?.name ?? '')} icon={<Copy size={14} />} />
              </UDTippy>
            )}
          </CustomField>
        </Label>
        <Label text="Тип спорта" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{t(`sportType.${organizer?.sportType}`)}</UDText>
          </CustomField>
        </Label>
        <Label text="Email" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.email}</UDText>
            {organizer?.email && (
              <UDTippy content={'Скопировать'} size={'xs'}>
                <EmptyButton color={theme.colors.Gray} onClick={() => onClickCopy(organizer?.email ?? '')} icon={<Copy size={14} />} />
              </UDTippy>
            )}
          </CustomField>
        </Label>
        <Label text="Телефон" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.phone}</UDText>
            {organizer?.phone && (
              <UDTippy content={'Скопировать'} size={'xs'}>
                <EmptyButton color={theme.colors.Gray} onClick={() => onClickCopy(organizer?.phone ?? '')} icon={<Copy size={14} />} />
              </UDTippy>
            )}
          </CustomField>
        </Label>
        <Label text="Город" className={'mb-4'}>
          <CustomField>
            <UDText type={'subhead'}>{organizer?.address.city}</UDText>
          </CustomField>
        </Label>
        <Label text="Описание" className={'mb-4'}>
          <CustomTextarea css={disableColor} readOnly rows={4} value={organizer?.description} />
        </Label>
      </div>
      <div className="w-1/2">
        <Label text="Информация о подписке организатора">
          <PlansBlock tournamentId={organizer?.id ?? 0} owner={organizer?.adminUser} />
        </Label>
      </div>
    </InfoContainer>
  );
});

export default OrganizerInfo;
